"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExecutionContext_1 = __importDefault(require("./ExecutionContext"));
const PRECISSION = 4;
function sameValue(v1, v2) {
    if (v1 === v2) {
        return true;
    }
    if (typeof v1 === 'number' &&
        Number.isNaN(v1) &&
        typeof v2 === 'number' &&
        Number.isNaN(v2)) {
        return true;
    }
    if (Array.isArray(v1) && Array.isArray(v2)) {
        if (v1.length === v2.length && v1.every((v, i) => sameValue(v, v2[i]))) {
            return true;
        }
    }
    if (typeof v1 === 'object' &&
        typeof v2 === 'object' &&
        JSON.stringify(v1) === JSON.stringify(v2)) {
        return true;
    }
    //console.log('Value changed from', v1, 'to', v2)
    return false;
}
function formatValue(def, value) {
    switch (def.format) {
        case 'float': {
            const v = parseFloat(value);
            return isNaN(v) ? 0 : Number(Number(v).toFixed(PRECISSION));
        }
        case 'integer': {
            const v = parseInt(value, 10);
            return isNaN(v) ? 0 : v;
        }
        case 'money': {
            const v = parseInt(value, 10);
            return isNaN(v) ? 0 : v;
        }
        case 'string': {
            return value;
        }
        case 'date': {
            const d = Date.parse(value);
            return isNaN(d) ? '' : value;
        }
    }
}
function buildGroup(def) {
    return {
        nodeType: 'group',
        def,
        formula: def.groupType === 'standard' ? () => 1 : buildFormula(def.formula),
        value: 0,
        displayValue: '',
        inputValue: '',
        visibility: def.visible ? buildFormula(def.visible) : () => 1,
        visible: true,
        children: [],
    };
}
function buildGroupInstance(def) {
    return {
        def,
        children: {},
        value: 1,
        displayValue: '1',
        inputValue: '',
        visibility: typeof def.visible === 'undefined' ? () => 1 : buildFormula(def.visible),
        visible: true,
        formula: () => 1,
        validation: def.validation
            ? {
                checkFormula: buildFormula(def.validation.check),
                messageFormula: buildMessageFormula(def.validation.message),
                type: def.validation.type,
                computedMessage: '',
            }
            : undefined,
    };
}
function buildField(def) {
    const field = Object.assign({ nodeType: 'field', def, value: undefined, displayValue: 'undef', inputValue: '', visible: true, visibility: def.visible
            ? buildFormula(def.visible, def.debugFormula || false)
            : undefined, validation: def.validation
            ? {
                checkFormula: buildFormula(def.validation.check, def.debugFormula || false),
                messageFormula: buildMessageFormula(def.validation.message, def.debugFormula || false),
                type: def.validation.type,
                computedMessage: '',
            }
            : undefined, formula: () => undefined }, buildFieldSpecifics(def));
    if (def.fieldType === 'input' && typeof def.default !== 'undefined') {
        field.formula = buildFormula(def.default, def.debugFormula || false);
    }
    else if (def.fieldType === 'computed') {
        field.formula = buildFormula(def.formula, def.debugFormula || false);
    }
    return field;
}
function buildFieldSpecifics(def) {
    switch (def.fieldType) {
        case 'computed':
            return {
                fieldType: 'computed',
            };
        case 'input':
            return Object.assign({}, buildInputFieldSpecifics(def));
    }
}
function buildInputFieldSpecifics(def) {
    switch (def.widget) {
        case 'input':
            return {
                fieldType: 'input',
                widget: 'input',
            };
        case 'date':
            return {
                fieldType: 'input',
                widget: 'date',
            };
        case 'select':
            return {
                fieldType: 'input',
                widget: 'select',
                options: buildOptionsFormula(def.options),
                optionsArray: [],
            };
    }
}
function buildFormula(formula, debug = false) {
    let strFormula = formula.replace(/'/g, '"').replace(/\n/g, '\\n');
    let strDebug = '';
    let strDebugEx = '';
    let strDebugger = '';
    if (debug) {
        console.log(formula);
        strDebugger = 'debugger;';
        strDebug = `console.log('${strFormula} => returns ' + res);`;
        strDebugEx = `
    console.error('Error calling ${strFormula}');
    console.error(e);`;
    }
    let funcBody = `
  with(context) {
    try {
      ${strDebugger}
      var res = (${formula});
      ${strDebug}
      return res;
    } catch(e) {
      ${strDebugEx}
      return undefined;
    }
  }
`;
    try {
        // eslint-disable-next-line no-new-func
        const f = new Function('context', funcBody);
        return f;
    }
    catch (e) {
        console.log(e);
        console.log('Failed to build formula ' + strFormula + ' ');
    }
    return () => {
        return 0;
    };
}
function buildMessageFormula(formula, debug = false) {
    let strFormula = formula.replace(/'/g, '"').replace(/\n/g, '\\n');
    let strDebug = '';
    let strDebugEx = '';
    let strDebugger = '';
    if (debug) {
        console.log(formula);
        strDebugger = 'debugger;';
        strDebug = `console.log('${strFormula} => returns ' + res);`;
        strDebugEx = `
    console.log('Error calling ${strFormula}');
    console.error(e);`;
    }
    let funcBody = `
  with(context) {
    try {
      ${strDebugger}
      var res = (\`${formula}\`);
      ${strDebug}
      return res;
    } catch(e) {
      ${strDebugEx}
      return undefined;
    }
  }
`;
    try {
        // eslint-disable-next-line no-new-func
        const f = new Function('context', funcBody);
        return f;
    }
    catch (e) {
        console.log(e);
        console.log('Failed to build formula ' + strFormula + ' ');
    }
    return () => {
        return 0;
    };
}
function buildOptionsFormula(formula) {
    let strFormula = formula.replace(/'/g, '"').replace(/\n/g, '\\n');
    // eslint-disable-next-line no-new-func
    return new Function('context', `
    with(context) {
      try {
        return (${formula});
      } catch(e) {
        console.log('Error calling ${strFormula}');
        console.error(e);
        return [];
      }
    }
  `);
}
function buildTablesMap(tables) {
    const map = {};
    tables.forEach((t) => {
        map[t.Nombre] = t.Datos;
    });
    return map;
}
function assign(value, node, path, values) {
    node.value = value;
    node.displayValue = typeof value !== 'undefined' ? value.toString() : '';
    values[path] = value;
}
function validate(node, path, newValue, env) {
    return node.validation
        ? node.validation.checkFormula(ExecutionContext_1.default(env, path, newValue, node.value))
        : true;
}
function buildValidationMsg(node, path, newValue, env) {
    return node.validation
        ? node.validation.messageFormula(ExecutionContext_1.default(env, path, newValue, node.value))
        : 'Undefined validation message';
}
function isSelectOptions(arg) {
    return (Array.isArray(arg) &&
        arg.every((i) => typeof i === 'object' && 'label' in i && 'value' in i));
}
class Engine {
    constructor(definition, tables) {
        this.definition = definition;
        this.root = buildGroup(definition.root);
        this.tables = buildTablesMap(tables);
    }
    getEnvironment() {
        return {
            root: this.root,
            tables: this.tables,
        };
    }
    getRoot() {
        return this.root;
    }
    getTables() {
        return Object.assign({}, this.tables);
    }
    _run(inputs, init = false) {
        const values = {};
        let errors = {};
        let root = null;
        try {
            while (this.root !== root) {
                errors = {};
                root = this.root;
                this.root = this.walk(this.root, '', inputs, values, errors, init);
            }
        }
        catch (error) {
            errors.unexpected_error = error;
        }
        console.log(errors);
        return {
            values: values,
            errors: errors,
        };
    }
    run(inputs) {
        return this._run(inputs, false);
    }
    load(inputs) {
        return this._run(inputs, true);
    }
    walk(node, path, inputs, values, errors, startup) {
        // Compute the value for this group
        const iterations = node.formula(ExecutionContext_1.default(this.getEnvironment(), path));
        let changed = this.calculateVisible(node, path, inputs, values);
        // Add/remove group instances
        if (node.value > iterations) {
            // Remove instances
            changed = true;
            node.children.splice(iterations, node.value - iterations);
        }
        if (node.value < iterations) {
            // Add instances
            changed = true;
            for (let i = node.value; i < iterations; i++) {
                node.children[i] = buildGroupInstance(node.def);
            }
        }
        assign(iterations, node, path, values);
        // Walk instances
        let childChanged = false;
        node.children.forEach((child, i) => {
            const newChild = this.walkInstance(child, path + '.' + i, inputs, values, errors, startup);
            childChanged = childChanged || newChild !== child;
        });
        if (childChanged) {
            node.children = [...node.children];
            changed = true;
        }
        if (typeof node.visibility !== 'undefined') {
            // check visibility change
            const visible = node.visibility(ExecutionContext_1.default(this.getEnvironment(), path));
            node.visible = visible;
            changed = !sameValue(visible, node.visible) || changed;
        }
        return changed ? Object.assign({}, node) : node;
    }
    walkInstance(node, path, inputs, values, errors, startup) {
        let changed = false;
        node.def.children.forEach((edChild) => {
            const key = edChild.name;
            const childPath = path + '.' + edChild.name;
            switch (edChild.nodeType) {
                case 'group': {
                    const child = (node.children[key] || buildGroup(edChild));
                    const updatedChild = this.walk(child, childPath, inputs, values, errors, startup);
                    changed = changed || child !== updatedChild;
                    node.children[key] = updatedChild;
                    return;
                }
                case 'field':
                    const child = (node.children[key] || buildField(edChild));
                    const isNewNode = typeof node.children[key] === 'undefined';
                    //force initialization for new nodes, avoid lazy evaluation
                    const updatedChild = this.calculate(child, childPath, inputs, values, errors, startup || isNewNode);
                    changed = changed || updatedChild !== child;
                    node.children[key] = child;
                    return;
            }
        });
        return changed
            ? Object.assign(Object.assign({}, node), { children: Object.assign({}, node.children) })
            : node;
    }
    calculateValue(node, path, inputs, values, errors, startup) {
        let value;
        if (startup &&
            node.def.nodeType === 'field' &&
            node.def.fieldType === 'input') {
            node.inputValue = formatValue(node.def, node.formula(ExecutionContext_1.default(this.getEnvironment(), path)));
            value = node.inputValue;
        }
        else {
            if (path in inputs) {
                //inputs values are assigned only if validates
                if (node.validation) {
                    //assign value only if validates
                    if (validate(node, path, inputs[path], this.getEnvironment())) {
                        node.validation.computedMessage = '';
                        node.inputValue = inputs[path];
                        value = formatValue(node.def, node.inputValue);
                    }
                    else {
                        node.validation.computedMessage = buildValidationMsg(node, path, inputs[path], this.getEnvironment());
                        errors[path] = {
                            path: path,
                            message: node.validation.computedMessage,
                            type: node.validation.type,
                        };
                        return false;
                    }
                }
                else {
                    node.inputValue = inputs[path];
                    value = formatValue(node.def, node.inputValue);
                }
            }
            else {
                value = formatValue(node.def, node.formula(ExecutionContext_1.default(this.getEnvironment(), path)));
                //validate current and default values too, to fire errors on computed fields
                if (node.validation) {
                    if (!validate(node, path, value, this.getEnvironment())) {
                        node.validation.computedMessage = buildValidationMsg(node, path, inputs[path], this.getEnvironment());
                        errors[path] = {
                            path: path,
                            message: node.validation.computedMessage,
                            type: node.validation.type,
                        };
                    }
                    else {
                        node.validation.computedMessage = '';
                    }
                }
            }
        }
        if (sameValue(value, node.value)) {
            values[path] = value;
            return false;
        }
        assign(value, node, path, values);
        return true;
    }
    calculateVisible(node, path, inputs, values) {
        if (node.visibility) {
            const visible = node.visibility(ExecutionContext_1.default(this.getEnvironment(), path));
            const changed = visible !== node.visible;
            if (changed) {
                node.visible = visible;
            }
            return changed;
        }
        return false;
    }
    calculateOptions(node, path) {
        if (!('options' in node))
            return false;
        const array = node.options(ExecutionContext_1.default(this.getEnvironment(), path));
        if (!isSelectOptions(array)) {
            throw new Error('Invalid formula output for select options');
        }
        const changed = !sameValue(node.optionsArray, array);
        node.optionsArray = array;
        return changed;
    }
    calculate(node, path, inputs, values, errors, startup) {
        let changed = this.calculateValue(node, path, inputs, values, errors, startup);
        changed = changed || this.calculateOptions(node, path);
        changed = changed || this.calculateVisible(node, path, inputs, values);
        return changed ? Object.assign({}, node) : node;
    }
}
exports.default = Engine;
